<template>
  <div class="content" style="padding: 0 1em; text-align: left;">
    <div v-html="content"/>
  </div>
</template>

<script>
export default {
  name: 'contentObj',
  props: [
    'sysId','fmtId'
  ],
  data () {
    return {
      content: ''
    }
  },
  created () {
    var vm = this
    this.$http
        .get('./WebApi/Apply/GetActionInfo/'.concat(this.sysId).concat('/').concat(this.fmtId))
        .then(function(response) {
          vm.content = response.data
        })
        .catch(function (error) {
          vm.$message.error('對不起,網路連線失敗');
        })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ContentView.vue